import urSwitch from "./urSwitch.vue";
export default {
    install(Vue){
        Vue.component(urSwitch.name, urSwitch);
    }
};
